import React, { useMemo } from 'react'
import { useStoreState, useStoreActions } from 'store'
import store from 'store'

const MoreOffersButton = () => {
  const { showMoreOffers } = useStoreActions(actions => actions.offers)
  const { pristineOffers, isLoading, pagination, pristineFeaturedOffers, showingStacked } = useStoreState(
    state => state.offers
  )
  const { onClickTracking } = useStoreActions(actions => actions.tracking)
  const offers = useStoreState(state => state.offers.offers)

  const hasShowMoreButton = useMemo(() => {
    const activeDisplayTab = store.getState().dimensions.activeDisplayTab
    let checkLength = activeDisplayTab === 'featured' ? pristineFeaturedOffers.length : pristineOffers.length
    return (
      !isLoading &&
      ((checkLength > offers.length && offers.length >= pagination.limit) ||
        (showingStacked && pristineOffers.length + pristineFeaturedOffers.length > offers.length))
    )
  }, [isLoading, offers.length, pagination, pristineOffers.length, showingStacked, pristineFeaturedOffers])

  const clickHandler = () => {
    onClickTracking({
      element: {
        type: 'button',
        location: 'rate table',
        position: 'bottom',
        text: 'show more results',
        name: 'show more results',
      },
      outcome: 'show more results',
    })
    showMoreOffers()
  }

  return (
    <>
      {hasShowMoreButton && (
        <div className="more-offers display-flex justify-content-center py-4">
          <button
            className="Button Button--secondary small"
            type="button"
            data-testid="show-more-button"
            onClick={clickHandler}
          >
            Show more results
          </button>
        </div>
      )}
    </>
  )
}

export default MoreOffersButton
